/* eslint-disable @typescript-eslint/no-explicit-any */
export function getStaticMethodNames<T>(target: T): string[] {
  return Object.getOwnPropertyNames(target).filter(
    name => typeof target[name as keyof typeof target] === 'function' && name !== 'constructor'
  );
}
